import src from "IMAGE";
export default { src, width: 758, height: 392, blurWidth: 0, blurHeight: 0};
